import { Box, Grid } from '@material-ui/core';
import { MerchantContract } from '@nemuru-eng/js-api-client';

import { PhoneFormDoubleField } from '@/components/shared/components/NewContextForms/PhoneFormDoubleField/PhoneFormDoubleField';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { CustomDivider } from '@/components/shared/components/CustomDivider';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { useScreen } from '@/hooks/useScreen';

interface CompanyManagerDetailsProps {
  merchantContract: MerchantContract;
}

export const CompanyManagerDetails = ({ merchantContract }: CompanyManagerDetailsProps) => {
  const { isMobile } = useScreen();
  return (
    <Box pt={6}>
      <Font variant="subtitle1" color="textPrimary">
        <Text tId={'COMPANY_MANAGER_DATA'} />
      </Font>
      <CustomDivider />
      <Grid container spacing={isMobile ? 0 : 4}>
        <Grid item xs={12}>
          <TextFormField
            label={'COMPANY_MANAGER_NAME'}
            value={`${merchantContract.companyManagerFirstName} ${merchantContract.companyManagerLastName}`}
            name={'company_manager_name'}
          />
          <TextFormField
            label={'ID_NUMBER'}
            value={merchantContract.companyManagerIdNumber}
            name={'company_manager_id_number'}
          />
          <TextFormField label={'EMAIL'} value={merchantContract.email} name={'email'} />
          <PhoneFormDoubleField fieldVariant={FieldVariant.dataRow} defaultValue={merchantContract.phoneNumber} />
        </Grid>
      </Grid>
    </Box>
  );
};
